import moment from 'moment';
import React from 'react';
import { withState, compose, withPropsOnChange, withHandlers } from 'recompose';
import ExportCsvButton from '../../reports/filters/ExportCsvButton';
import { t } from '../../../../modules/infra/i18n';


const Radio = ({ value, checked, onChange }) => (
  <label className="c-radio u-mr-" htmlFor={`${value}visit`}>
    <input type="radio" id={`${value}visit`} value={value} checked={checked} className="c-radio__input" name="visits" onChange={onChange} />
    <span className="c-radio__trigger" />
    <span className="c-radio__label">
      {value} {value > 1 ? t('customers:retention.visits_plural') : t('customers:retention.visit_singular')}
    </span>
  </label>
);

const RetentionReportFilters = ({
  quarter,
  setQuarter,
  quarters,
  setRetainedVisitsCount,
  retainedVisitsCount,
  downloadCsv
}) => (
  <div className="layout u-mb">
    <div className="layout__item u-1/3">
      <div className="c-label">{t('customers:retention.quarter_label')}</div>
      <select className="c-select" onChange={e => setQuarter(e.target.value)} value={quarter}>
        {quarters.map(q => (
          <option value={`${q.quarter}-${q.year}`} key={q.stringFormat}>
            {q.stringFormat}
          </option>
        ))}
      </select>
    </div>
    <div className="layout__item u-1/3">
      <div className="c-label">{t('customers:retention.visits_to_qualify_label')}</div>
      {[1, 2, 3].map(num => (
        <Radio value={num} checked={retainedVisitsCount === num} onChange={() => setRetainedVisitsCount(num)} />
      ))}
    </div>
    <div className="layout__item u-1/3">
      <ExportCsvButton csv={downloadCsv} />
    </div>
  </div>
);

export default compose(
  withState('quarter', 'setQuarter', () => {
    const previousQuarter = moment().subtract(1, 'quarter');
    return `${previousQuarter.quarter()}-${previousQuarter.year()}`;
  }),
  withState('retainedVisitsCount', 'setRetainedVisitsCount', props => props.customerRetainedVisitsCount),
  withHandlers({
    downloadCsv: props => () => {
      const [quarter, year] = props.quarter.split('-');
      return props.getCsv(quarter, year, props.retainedVisitsCount);
    },
  }),
  withPropsOnChange(['quarter', 'retainedVisitsCount'], (props) => {
    if (props.quarters.length && props.quarter && props.retainedVisitsCount) {
      const [quarter, year] = props.quarter.split('-');
      props.onChange(quarter, year, props.retainedVisitsCount);
    }
  }),
)(RetentionReportFilters);
